import axios from 'axios';

async function ObtenerPlanes(prmFiltro: string = '', prmIdPlan: number = 0) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/obtener_planes"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "filtro": prmFiltro,
            "idplan": prmIdPlan
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default ObtenerPlanes;